export default __webpack_public_path__ + "assets/92799044883d38b9e62f139dcf6ae225.png";